import "../../../ReactComponents/Components/Companies/CompanyDetails";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import CompanyDetailsReactWrapperController from "./CompanyDetailsReactWrapperController";

export default class CompanyDetailsReactWrapper implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public template: string;

    constructor() {
        this.bindings = {
            companyId: "<",
        };
        this.controller = CompanyDetailsReactWrapperController;
        this.template = "<CompanyDetails></CompanyDetails>";
    }
}

module("mmManagePortal").component("irCompanyDetailsReactWrapper", new CompanyDetailsReactWrapper());
